//import Vue from 'vue'
import Eventcalculator from './Eventcalculator.vue'

const eventCalculatorEl = document.getElementById('eventcalculator')

if(eventCalculatorEl) {
    new Vue(Eventcalculator)
}